// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Ni1W","col":"styles_col__c4vdb"};